import React, { Component } from 'react';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import Spinner from '../config/Spinner';

import Home from './Home';
import Login from './Login';
import { ToastContainer,  } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import history from '../config/history';

class App extends Component { 


  render() {
    const { auth } = this.props;
    return (
      <div>
        <Spinner/>
        <ToastContainer/>
        <ReduxToastr />
        
        <Router history={history} >
          <Switch>
            {/* DEV: Auth commented out for development */}
            {
              auth ? <Route path="/" name="Home" component={Home} /> : 
               <Route path="/" name="Login Page" component={Login} />
            }
            {/* <Route path="/" name="Home" component={Home} /> */}
          </Switch>
        </Router>
      </div>

    );
  }
}

function mapStateToProps({ auth }) {
  return {
    auth
  };
}



export default connect(mapStateToProps, null)(App);
